<template>
  <span
    class="activity-status-label uppercase font-black tracking-wide text-center rounded"
    :class="[
      `bg-${labels[status]}`,
      status === 9 ? 'activity-status-label--pending-rescheduling' : 'text-white',
    ]"
    :style="{ fontSize: fontSize + 'rem' }"
  >
    {{ $t(labels[status]) }}
  </span>
</template>

<script>

export default {
  name: 'activity-status-label',

  props: {
    status: { type: Number, default: 0 },
    fontSize: {type: String, default: "0.4"}
  },

  data: () => ({
    labels: [
      'activity_status_assigned',
      'activity_status_running',
      'activity_status_paused',
      'activity_status_issue',
      'activity_status_done',
      'activity_status_reopened',
      'activity_status_closed',
      'activity_status_delayed_start',
      'activity_status_delayed',
      'activity_status_pending_rescheduling',
    ],
  }),

};
</script>
<style scoped>
  .activity-status-label {
    display: inline-block;
    max-width: 100%;
    padding: 0.2rem 0.45rem;
    line-height: 1.25;
    word-break: break-word;
    box-decoration-break: clone;
    -webkit-box-decoration-break: clone;
  }

  .bg-activity_status_assigned {
    background-color: #B8C2CC;
  }
  .bg-activity_status_delayed_start {
    background-color: #fc8a18;
  }
  .bg-activity_status_delayed {
    background-color: #f9c74f;
  }
  .bg-activity_status_running {
    background-color: #3490dc;
  }
  .bg-activity_status_paused {
    background-color: #F6993F;
  }
  .bg-activity_status_issue {
    background-color: #e3342f;
  }
  .bg-activity_status_done {
    background-color: #6574CD;
  }
  .bg-activity_status_reopened {
    background-color: #9561E2;
  }
  .bg-activity_status_closed {
    background-color: #38C172;
  }
  .bg-activity_status_pending_rescheduling {
    background-color: #fef3c7;
    border: 1px solid #fcd34d;
  }

  .activity-status-label--pending-rescheduling {
    color: #92400e;
  }
</style>
